import React from "react";
import { Box, Paper, Table, TableBody, TableContainer, TableHead, Typography } from "@mui/material";

type TableProps = {
  searchLen: number;
  tableHeadElement: () => JSX.Element;
  tableBodyElement: () => JSX.Element | null;
};

/**
 * 倉庫情報一覧テーブル
 */
function WarehouseTable({ searchLen, tableHeadElement, tableBodyElement }: TableProps) {
  return (
    <>
      <Box
        mt={3}
        display="flex"
        flexDirection="row"
        borderBottom={4}
        borderColor="primary.main"
        justifyContent="flex-start"
      >
        <Box display="flex" flexDirection="row" justifyContent="space-between" width="100%">
          <Box display="flex" flexDirection="row">
            <Box textAlign="left" display="flex" flexDirection="row" alignItems="flex-end">
              <Typography fontSize={20}>登録倉庫件数</Typography>
              <Typography fontSize={20}>&emsp;{searchLen}件</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box mt={2}>
        {/* 表 */}
        <TableContainer
          component={Paper}
          sx={{ overflowX: "initial", width: "fit-content", minWidth: "100%" }}
        >
          <Table sx={{ width: "100%", borderCollapse: "separate" }} aria-label="order table">
            <TableHead>{tableHeadElement()}</TableHead>
            <TableBody>{tableBodyElement()}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}

export default React.memo(WarehouseTable);
